module.exports = __webpack_public_path__ + "static/media/s3.58ee4ad7.png";